/* istanbul ignore next */
export const off = (function () {
    if (document && document.removeEventListener) {
        return function (element, event, handler) {
            if (element && event) {
                element.removeEventListener(event, handler, false);
            }
        };
    } else {
        return function (element, event, handler) {
            if (element && event) {
                element.detachEvent('on' + event, handler);
            }
        };
    }
})();

/* istanbul ignore next */
export const on = (function () {
    if (document && document.addEventListener) {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.addEventListener(event, handler, false);
            }
        };
    } else {
        return function (element, event, handler) {
            if (element && event && handler) {
                element.attachEvent('on' + event, handler);
            }
        };
    }
})();

export function preventDefault(e: Event): void {
	e.preventDefault()
}

// set element inline style
type objectKeyOnlyCss = {
    [k in keyof CSSStyleDeclaration]?: any
}
export function setStyle(
	imgElement: HTMLElement | null,
	styleObj: objectKeyOnlyCss
) {
	for (const key in styleObj) {
		imgElement!.style[key] = styleObj[key]
	}
}

// set element Properties
export function setProperties(
	imgElement: HTMLElement | null,
	properties: object
) {
	for (const key in properties) {
		imgElement!.style.setProperty(key, properties[key])
	}
}

export function getElementRect(el: Element | null): DOMRect {
	return el!.getBoundingClientRect()
}

// 页面绘制后的下一帧回调
export function nextTick(fn: () => void) {
	requestAnimationFrame(fn)
}

/**
 * check element is hidden by css
 * @param el check el
 * @param  bubblingLevel The level to look up from the current element 
 * @returns {boolean}
 */
 export function isElementHiddenByCss(el: Element | null, bubblingLevel: number): boolean {
	if (!el) return false
	while (bubblingLevel-- && el) {
		const { visibility, height, opacity, width } = getComputedStyle(el)
		if (visibility === 'hidden' || height === '0px' || width === '0px' || opacity === '0') {
			return false
		}
    el = el?.parentElement
	}
	return true
}

/**
 * 判断一个元素是否出现在当前视口中
 * @param el 要判断的元素
 * @returns {boolean}
 */
 export function isElementInViewport(el: any, bubblingLevel: number): boolean {
	const rect = getElementRect(el)
	const vWidth = window.innerWidth || document.documentElement.clientWidth
	const vHeight = window.innerHeight || document.documentElement.clientHeight
	// if element display:none or transform:scale(0)
	if (rect.width === 0 || rect.height === 0) {
		return false
	} else if (rect.right < 0 || rect.bottom < 0 || rect.left > vWidth || rect.top > vHeight) {
		return false
	} else {
		return isElementHiddenByCss(el, bubblingLevel)
	}
}

// set element data-* attr
export function setDataset(el: HTMLElement, key: string, value: string) {
	if (el.dataset) {
		el.dataset[key] = value
	} else {
		el.setAttribute('data-' + key, value)
	}
}

export const slotAssignedElements = (nodes: any[]) => {
	if (!nodes || nodes.length <= 0) {
	  return [];
	}
	return nodes.filter((node) => node.nodeType === Node.ELEMENT_NODE);
};

export const addEventListener = (el: any, eventName: string, callback: any, opts?: any) => {
	return el.addEventListener(eventName, callback, opts);
};